import React from 'react'
import { inject, observer } from 'mobx-react'

import Categories from './Categories'

const Explore = ({ dropdownStore, translationStore, exploreStore, location }) => {
  const ifItsAHandheldDevice = (doThis) => {
    if(window.outerWidth < 1024) return doThis
  }

  const ifItsPC = (doThis) => {
    if(window.outerWidth >= 1024) return doThis
  }

  const marginTop = ((dropdownStore.showSearchDropdown || dropdownStore.showProfileDropdown)
                      && 'mt-dropdown')

  const showCategoriesClass = exploreStore.isShowingCategories ? 'active' : ''

  return (
        <div
          onMouseEnter={ifItsPC(exploreStore.expand)}
          onMouseLeave={ifItsPC(exploreStore.collapse)}
          onClick={ifItsAHandheldDevice(exploreStore.toggle)}
          onBlur={ifItsAHandheldDevice(exploreStore.collapse)}
          // className='header__nav__explore'
          className={`header__nav__explore ${showCategoriesClass}`}
          name='step-3'
        >
        <span className='header__nav__explore__hd'>
          {translationStore.translate('header_explore_headline')}
        </span>
        <div
          onClick={exploreStore.collapse}
          className="header__nav__explore__dropdown"
        >
            <Categories location={location} />
        </div>
      </div>
  )
}

export default inject('dropdownStore', 'translationStore', 'exploreStore')(observer(Explore))



// WEBPACK FOOTER //
// ./src/components/Header/Explore/index.js